EmojiProvider = require 'lib/emoji-provider'
EmojiProviderComponent = require('./emoji-provider-component')
NimblePicker = require('emoji-mart/dist-es/components/picker/nimble-picker').default
React = require 'react'
t = require('views/internal/recup-with-helpers')('reactions')
_ = require 'underscore'

module.exports = class TrelloEmojiPicker extends React.Component
  @defaultProps:
    title: ''
    emoji: ''
    color: '#0079BF'
    set: 'twitter'
    i18n:
      search: t.l('search'),
      notfound: t.l('no-emoji-found'),
      skintext: t.l('skintext')
      categories:
        search: t.l('categories-search-results'),
        recent: t.l('categories-frequently-used'),
        people: t.l('categories-smileys-and-people').replace(/&amp;/g, '&'), #escaped ampersands are not handled by emojimart
        nature: t.l('categories-animals-and-nature').replace(/&amp;/g, '&'),
        foods: t.l('categories-food-and-drink').replace(/&amp;/g, '&'),
        activity: t.l('categories-activity'),
        places: t.l('categories-travel-and-places').replace(/&amp;/g, '&'),
        objects: t.l('categories-objects'),
        symbols: t.l('categories-symbols'),
        flags: t.l('categories-flags'),
        custom: t.l('categories-custom')
    style: { 'width': '408px' }
    emojiSize: '28px'
    backgroundImageFn: EmojiProvider.getSpritesheetsUrl,
    skinEmoji: 'v'
    autoFocus: true
    notFound: =>
      React.createElement 'div', className: "emoji-mart-no-results",
        React.createElement 'div', { className: "emoji-mart-no-results-label" }, t.l('no-emoji-found')
        React.createElement 'img', { className: "emoji-mart-no-results-img", src: require('images/illos.png') }

  componentDidMount: ->
    document.querySelector('#chrome-container').scrollTop = 0

  render: ->
    # Prevents the notifications popover from closing
    React.createElement 'div', { onClick: (e) ->  e.preventDefault() },
      React.createElement EmojiProviderComponent, null, (data) =>
        React.createElement NimblePicker, _.extend {}, @props, { data }



// WEBPACK FOOTER //
// ./app/scripts/views/emoji/trello-emoji-picker.coffee